import styled from 'styled-components';
import { theme } from '../theme';

export const OnboardingContainer = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  background: ${theme.colors.background.primary};
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;
  position: relative; /* Stabilize for absolute/sticky children */

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding-bottom: 90px;
  }
`;

export const StepContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.xl} ${theme.spacing.lg};
  max-width: 800px;
  margin: 0 auto;
  width: 100%;

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.lg} ${theme.spacing.md};
  }
`;

export const StepTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.md} 0;
  text-align: center;

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1.75rem;
  }
`;

export const StepDescription = styled.p`
  font-size: 1.1rem;
  color: ${theme.colors.text.secondary};
  margin: 0 0 ${theme.spacing.xl} 0;
  text-align: center;
  line-height: 1.6;

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1rem;
  }
`;

export const StepContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.lg};
`;

export const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${theme.spacing.xl} 0;
  gap: ${theme.spacing.lg};
`;

export const WelcomeIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${theme.spacing.md};
  color: ${theme.colors.primary};

  svg {
    width: 64px;
    height: 64px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    svg {
      width: 48px;
      height: 48px;
    }
  }
`;

export const WelcomeTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.spacing.md} 0;

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 2rem;
  }
`;

export const WelcomeDescription = styled.p`
  font-size: 1.2rem;
  color: ${theme.colors.text.secondary};
  margin: 0 0 ${theme.spacing.xl} 0;
  line-height: 1.6;
  max-width: 600px;

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1.1rem;
  }
`;

export const WelcomeFeatures = styled.ul`
  list-style: none;
  padding: 0;
  margin: ${theme.spacing.xl} 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  max-width: 500px;
  width: 100%;
`;

export const WelcomeFeature = styled.li`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.md};
  background: ${theme.colors.background.card};
  border-radius: ${theme.borderRadius.md};
  font-size: 1rem;
  color: ${theme.colors.text.primary};
`;

export const FeatureIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${theme.colors.primary};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const FeatureText = styled.span`
  flex: 1;
`;

export const TimeEstimate = styled.div`
  padding: ${theme.spacing.md};
  background: ${theme.colors.background.secondary};
  border-radius: ${theme.borderRadius.md};
  color: ${theme.colors.text.secondary};
  font-size: 0.9rem;
  margin-top: ${theme.spacing.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.xs};

  svg {
    width: 16px;
    height: 16px;
    color: ${theme.colors.text.secondary};
  }
`;

